require('./dist/angular-local-storage.js');
module.exports = 'LocalStorageModule';



//////////////////
// WEBPACK FOOTER
// ../~/angular-local-storage/index.js
// module id = 374
// module chunks = 1